import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentLine } from '../classes/shipmentline';
import { BaseService } from './base.service';
import { ConfigurationHelper } from '../helper/configuration.helper';
import { HttpClient } from './http.service';
import { Logger } from '../logging/default-log.service';

/**
 * Service to handle the calls to the backend for the ShipmentLines  'usp_GetShipmentLines'
 */
@Injectable()
export class ShipmentLineService extends BaseService {
  constructor(
    private http: HttpClient,
    logger: Logger
  ) {
    super(logger);
  }

  /**
   * Get the shipment lines with the historical data
   * @return {Observable<ShipmentLine[]>}
   */
  getShipmentLines(
    priceListNo: string,
    priceListLineNo: string,
    numberOfLines: number
  ): Observable<ShipmentLine[]> {
    const url = new URL(ConfigurationHelper.getWebshopUrl('/public/rest/product-order-history'));

    if (priceListNo != null) {
      url.searchParams.append('priceListNo', priceListNo);
    }

    if (priceListLineNo != null) {
      url.searchParams.append('priceListLineNo', priceListLineNo);
    }

    if (numberOfLines != null) {
      url.searchParams.append('numberOfLines', numberOfLines.toString());
    }

    return this.http.get<ShipmentLine[]>(url.href);
  }
}
